export default "__VITE_ASSET__DXRIXzik__"